import { Box, Flex, Text } from "@chakra-ui/react"
import { useState } from "react"
import { useRecoilValue } from "recoil"
import { Logo } from "src/components/header/logo"
import { brandingSelector } from "src/recoil/atoms/room"
import styles from "./animations.module.css"

export default function LogoLoader() {
  const roomStyles = useRecoilValue(brandingSelector)

  const [finalStateClass, setFinalStateClass] = useState("")

  return (
    <Flex
      minH="calc(100vh)"
      align="center"
      justify="center"
      bg="white"
      bgRepeat="no-repeat"
      pos="absolute"
      left="0"
      top="0"
      w="100%"
    >
      <Box
        position="absolute"
        className={`${styles.rotation} ${
          finalStateClass.length ? styles[finalStateClass] : ""
        }`}
        onAnimationEnd={() => {
          setFinalStateClass("continue")
        }}
      >
        <Logo src={roomStyles?.logo} />
      </Box>
      <Text
        fontFamily="Roboto"
        fontWeight="bold"
        top="2.6rem"
        pos="relative"
        textTransform="uppercase"
        letterSpacing="2px"
        className={styles.text}
      >
        Loading
      </Text>
    </Flex>
  )
}
